import React from 'react';
import SubmitInvoice from '../../fCommon/Submit/MultiSubmitInvoice';

export const SubmitInvoiceAsn = (props) => {
    const vendorData = {
        id: props.vendorId,
        name: props.vendorName,
        code: props.vendorCode,
        gstin: undefined,
    };


    return (
        <div style={{position:'relative'}}>
        <SubmitInvoice
            currency={"INR"}
            onClose={() => {
                props.onClose()
            }}
            init={props.init}
            category={props.category}
            categoryId={props.categoryId}
            poId={props.poId}
            vendorId={props.vendorId}
            asnId={props.id}
            onlyInvoice={true}
            disableAsn={props.disableAsn}
            multi={true}
            data={{
                vendor: vendorData,
                billingTo: {
                    name: props.officeName,
                    value: props.officeId,
                    label: props.officeName,
                    gstin: undefined,
                    address: props.officeAddress || '-'
                },
                shipTo: {
                    name: props.officeName,
                    value: props.officeId,
                    label: props.officeName,
                    gstin: undefined,
                    address: props.officeAddress || '-'
                }
            }}
            lineItems={props.items.filter(i => i.qty !== i.approved && !i.shortClosure).map(val => {
                let qty = val.qty || 0;
                if ((val.qty - val.approved) > 0) {
                    qty = val.qty - val.approved
                }
                let price = val.price || 0;
                let taxSlab = val.taxSlab || 0;
                let hsn = val.hsn || '';
                let discountSlab = 0;

                let base = price * qty;
                let grossBase = base - (base * (discountSlab / 100));
                let tax = (grossBase * (taxSlab / 100))
                return (
                    {
                        itemId: val.poItemId,
                        name: val.name,
                        budgetStatus: val.budgetStatus,
                        budgetId: val.budgetId,
                        budgetAmount: val.budgetAmount,
                        qtty:qty.toFixed(2),
                        price: price,
                        hsn: hsn,
                        base: price * qty,
                        grossBase,
                        gst: taxSlab,
                        taxSlab: taxSlab,
                        tax,
                        ...(val.attrs && val.attrs.autoBudgeting) ? { autoBudgeting: (val.attrs.autoBudgeting === "yes") ? true : false } : {},
                        total: tax + grossBase,
                        productId: val.productId,
                        service: {
                            label: val.serviceName,
                        },
                        productCode: val.productCode ? val.productCode : null,
                        description: val.description,
                        key: `${val.poItemId}||${hsn}||${qty}`,
                    }
                )
            })}
        />
        </div>
    );
};